<template>
    <div v-if="isLoading" class="loader-container">
        <img src="@/assets/images/loading-36.gif" height="80" width="80" />
    </div>
</template>
  
<script>
    export default {
        name: 'TheLoader',
        props: {
            isLoading: {
                type: Boolean,
                required: true
            }
        },
    };
</script>
  
<style scoped>
    .loader-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }
</style>